import React, {useState, useEffect} from 'react';
import classNames from 'classnames';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import styles from './NavBar.module.scss';
import SocialIcons from "../Global/SocialIcons/SocialIcons";
import NavbarToggle from "./NavbarToggle";

interface NavItemType {
    id: number;
    title: string;
    link: string;
    disabled: boolean;
}

const navItems: NavItemType[] = [
    {id: 0, title: 'Продукты', link: '#products', disabled: false},
    {id: 1, title: 'Сервисы', link: '#services', disabled: false},
    {id: 2, title: 'Технологии', link: '#technologies', disabled: false},
    {id: 3, title: 'Платформы', link: '#platforms', disabled: false},
    {id: 4, title: 'Контакты', link: '#contacts', disabled: false},
];

const NavBar = () => {
    const [isOpen, setIsOpen] = useState(false);

    // Обработчик для переключения состояния меню
    const handleToggle = () => setIsOpen(prevState => !prevState);

    // Закрыть меню при клике на элемент (только если меню открыто)
    const handleNavClick = (event: React.MouseEvent<HTMLElement>, id: string) => {
        if (isOpen) {
            setIsOpen(false);  // Закрываем меню, если оно открыто
        }
        const target = document.getElementById(id.replace('#', ''));
        if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' }); // Плавный скроллинг
        }
    };

    // Используем useEffect для манипуляции с body в зависимости от состояния меню
    useEffect(() => {
        if (isOpen) {
            // Если меню открыто, добавляем стиль для запрета прокрутки
            document.body.style.overflow = 'hidden';
        } else {
            // Если меню закрыто, восстанавливаем обычное поведение прокрутки
            document.body.style.overflow = 'auto';
        }

        // Возвращаем функцию очистки, которая удаляет стили при размонтировании компонента
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOpen]); // Зависимость от isOpen

    return (
        <Navbar expand="lg" className={styles.customNavBar}>
            <Container>
                <div className="d-flex align-items-center justify-content-between w-100">
                    <Navbar.Brand href="#home">
                        <img loading="lazy" src="./assets/icon/logo.svg" className="img-fluid" alt="ELS"/>
                    </Navbar.Brand>
                    <NavbarToggle isOpen={isOpen} onClick={handleToggle} className={styles.navToggle}/>
                </div>
                <Navbar.Collapse
                    className={classNames(styles.navCollapse, {
                        [styles.show]: isOpen,
                        'collapse': true,
                        'navbar-collapse': true,
                    })}
                >
                    <Nav className={styles.navbarNav}>
                        {navItems.map((item) => (
                            <Nav.Link
                                key={item.id}
                                href={item.link}
                                className={styles.navText}
                                disabled={item.disabled}
                                onClick={(e) => handleNavClick(e, item.link)}  // Закрываем меню при клике на элемент
                            >
                                {item.title}
                            </Nav.Link>
                        ))}
                    </Nav>
                    <SocialIcons className={styles.navSocial}/>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default NavBar;
